/**
 * Utility functions for the audit system
 */

import { DateRangeFilter } from './types';

/**
 * Get default date range (last 7 days from today)
 */
export function getDefaultDateRange(): DateRangeFilter {
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
  sevenDaysAgo.setHours(0, 0, 0, 0);

  return {
    from: sevenDaysAgo,
    to: today,
  };
}
